import * as React from "react";
import type { SVGProps } from "react";
const SvgTarget04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#000"
      d="M12 12v-1a1 1 0 0 0-1 1zm.085 0h1a1 1 0 0 0-1-1zm0 .077v1a1 1 0 0 0 1-1zm-.085 0h-1a1 1 0 0 0 1 1zM21.6 12h-1a8.6 8.6 0 0 1-8.6 8.6v2c5.854 0 10.6-4.746 10.6-10.6zM12 21.6v-1A8.6 8.6 0 0 1 3.4 12h-2c0 5.854 4.746 10.6 10.6 10.6zM2.4 12h1A8.6 8.6 0 0 1 12 3.4v-2C6.146 1.4 1.4 6.146 1.4 12zM12 2.4v1a8.6 8.6 0 0 1 8.6 8.6h2c0-5.854-4.746-10.6-10.6-10.6zm4.8 9.6h-1a3.8 3.8 0 0 1-3.8 3.8v2a5.8 5.8 0 0 0 5.8-5.8zM12 16.8v-1A3.8 3.8 0 0 1 8.2 12h-2a5.8 5.8 0 0 0 5.8 5.8zM7.2 12h1A3.8 3.8 0 0 1 12 8.2v-2A5.8 5.8 0 0 0 6.2 12zM12 7.2v1a3.8 3.8 0 0 1 3.8 3.8h2A5.8 5.8 0 0 0 12 6.2zm0 4.8v1h.085v-2H12zm.085 0h-1v.077h2V12zm0 .077v-1H12v2h.085zm-.085 0h1V12h-2v.077z"
    />
  </svg>
);
export default SvgTarget04;
